/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { Component } from 'react';
import { Image, Link } from '@sitecore-jss/sitecore-jss-react';

import * as styles from './index.styles';
import {
  navbar_finite_state,
  NavConsumer,
} from '../../../../contexts/NavContext';
import { get } from 'lodash';
import { modalIds, ModalsConsumer } from '../../../../contexts/ModalsContext';
import { withNamespaces } from 'react-i18next';
import compose from 'lodash/fp/compose';
import { withConsumer } from '../../../../contexts';
import { Breakpoints } from '../../../../styles/Grid/GridSizes';
import { CLOUDINARY_BASE_VALUES } from '../../../../utils/constants';
import { Picture } from '../../../ui/Picture';

const GetCardAnchor = props => {
  const { item, children, openModal, modalsContext } = props;

  const isModal = get(item, 'fields.Link.value', '');

  if (
    isModal &&
    typeof isModal === 'string' &&
    (isModal === 'SEARCH_LOCATIONS' || isModal === 'SEARCH_LOCATION')
  ) {
    let modalId = navbar_finite_state.SEARCH;
    return (
      <button
        css={[styles.cardscomponent, styles.cardsWithButton]}
        onClick={() => {
          openModal({
            target: { dataset: { id: modalId } },
          });
        }}
      >
        {children}
      </button>
    );
  }
  if (isModal && typeof isModal === 'string' && isModal === 'BOOK_VISIT') {
    return (
      <button
        css={[styles.cardscomponent, styles.cardsWithButton]}
        onClick={() => modalsContext.openModal(modalIds.bookVisit, {})}
      >
        {children}
      </button>
    );
  }

  return (
    <Link field={item.fields.Link} css={[styles.cardscomponent]}>
      {children}
    </Link>
  );
};

const mainImageSizes = {
  [Breakpoints.sm]: {},
  [Breakpoints.md]: {},
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
  },
};

class Card extends Component {
  render() {
    const { item } = this.props;
    const { modalsContext } = this.props;

    const icon = get(item, 'fields.Icon', '');
    const Heading = get(item, 'fields.Heading.value', '');
    const alt = get(icon, 'value.alt', '');
    if (!alt) {
      icon.value.alt = Heading;
    }
    // icon.value.src = 'http://regus.dev.local/' + icon.value.src;

    return (
      <NavConsumer>
        {({ openModal }) => (
          <GetCardAnchor
            item={item}
            openModal={openModal}
            modalsContext={modalsContext}
          >
            <div className="card_sec">
              <Picture
                image={icon}
                imageSizes={mainImageSizes}
                editable={false}
              />
              <div className="textsec">
                <h3>
                  <span>{item.fields.Heading.value}</span>
                </h3>
                <p>{item.fields.Strapline.value}</p>
              </div>
            </div>
          </GetCardAnchor>
        )}
      </NavConsumer>
    );
  }
}

export default compose(
  withNamespaces(),
  withConsumer(ModalsConsumer, 'modalsContext'),
)(Card);
